import request from "@/utils/request";

export function getLog(data) {
  return request({
    url: "/operLog/query",
    method: "post",
    data,
  });
}
